import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Dashboard from './Dashboard.vue'
import AppHeader from '../../components/layout/AppHeader'
// import AppSidebar from '../../components/layout/AppSidebar'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/dashboard',
      name: 'dashboard',
      components: {
        default: Dashboard,
        header: AppHeader,
        // aside: AppSidebar
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
